var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroLaptopManWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 511,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M512.3 65.9c25.9-33.7 5.1-59.5 5.1-59.5s-24.8 21.9-5.1 59.5ZM502.2 87.6c1.7-39.5-27.9-48.1-27.9-48.1s-7.3 30 27.9 48.1ZM514.6 88.2C554.2 88 561.4 58 561.4 58s-30.4-5.8-46.8 30.2ZM505.4 115.5c40.7 12.4 57.6-16.2 57.6-16.2s-29.3-15.6-57.6 16.2ZM492.8 141.6c39.1 23.1 63.8-2.3 63.8-2.3s-26.4-23.5-63.8 2.3ZM491.7 111.6c-8.6-41.3-41.4-42.4-41.4-42.4s.4 32.9 41.4 42.4ZM478.7 135.6C464.4 90 426.9 97 426.9 97s4 38 51.8 38.6ZM462.5 159.6c-18-44.2-54.8-34-54.8-34s7.2 37.5 54.8 34Z",
    fill: "#036C1C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M440.7 184.2c-13.7-45.8-51.3-39.1-51.3-39.1s3.5 38.1 51.3 39.1ZM476.1 166.4c33 31.2 62.7 12 62.7 12s-20.5-28.9-62.7-12ZM455.9 192.5c32.5 31.7 62.5 12.9 62.5 12.9s-20.1-29.2-62.5-12.9Z",
    fill: "#036C1C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M499.1 115.9c2.9-7 5.3-13.8 7.2-20.4.2-.5.3-1.1.5-1.6 10-5.9 19.7-12 26.9-16.8 7.3-4.8 11.9-8.2 11.9-8.3 0 0-4.9 3.2-12.4 7.7-7.1 4.3-16.4 9.7-25.8 15.3 5-17.9 6.5-33.4 6.9-44.3.2-5.9.1-10.4 0-13.6-.1-3.1-.2-4.8-.2-4.8s.1 1.7.1 4.9 0 7.8-.4 13.8c-.7 11-2.6 26.4-7.9 44-5.3-8.8-10.6-17.4-14.6-23.8l-7-11.2s2.5 4.8 6.4 11.7c3.9 7 9.2 16.2 14.6 25.2-.2.7-.4 1.4-.7 2.1-2.1 6.5-4.6 13.3-7.7 20.2-7.4-8-14.9-15.7-20.6-21.4-5.9-6-10-9.7-10-9.7s3.9 4.1 9.6 10.4c5.6 6.1 12.9 14.2 20.4 22.2-1.3 2.8-2.6 5.7-4 8.5-2.3 4.6-4.8 9.2-7.4 13.7-8.7-6.5-17.4-12.7-24-17.3-6.9-4.8-11.6-7.8-11.6-7.8s4.6 3.3 11.3 8.5c6.5 4.9 15 11.4 23.5 17.9-3.2 5.4-6.7 10.8-10.4 16.1-1.5 2.1-3 4.2-4.5 6.2-9.3-5.8-18.5-11.3-25.5-15.3-7.3-4.2-12.2-6.8-12.2-6.8s4.9 2.9 12 7.5c6.8 4.3 15.8 10.1 24.8 15.7-5.8 7.7-12.2 15.3-19.1 22.5-.6.6-1.2 1.3-1.8 1.9-8.8-6.8-17.6-13.2-24.3-18-6.8-4.9-11.5-7.9-11.5-7.9s4.5 3.4 11.2 8.6c6.5 5 15 11.7 23.6 18.3-3.6 3.7-7.4 7.4-11.3 10.9-2.5 2.2-5 4.4-7.5 6.5-1.3 1.1-2.6 2.1-3.9 3.1l-2 1.5-1 .7-.5.3-.2.2-.1.1c.1.2.6 1 .6 1.2v.1l.6 1.3s.3-.1.2-.1l.1-.1.2-.1.3-.2.5-.4 1.1-.8c.7-.5 1.4-1 2.1-1.6 1.4-1.1 2.7-2.1 4-3.2 2.6-2.2 5.2-4.5 7.7-6.8 4.1-3.7 8-7.6 11.8-11.6 11.2 3.4 22.2 6.5 30.6 8.6 8.4 2.2 14.1 3.2 14.1 3.2s-5.7-1.4-14.1-4c-8.1-2.4-18.8-5.8-29.5-9.1.5-.5 1-1 1.5-1.6 6.9-7.5 13.3-15.2 19.1-23.1 11.1 2.5 22.1 4.6 30.4 6 8.6 1.5 14.3 2.1 14.3 2.1s-5.8-1-14.3-2.8c-8.1-1.7-18.8-4.1-29.5-6.5 1.5-2.1 3-4.2 4.5-6.4 3.6-5.2 6.9-10.5 9.9-15.8 11.6.7 23 1.1 31.5 1.1 8.7.1 14.5-.2 14.5-.2s-5.9 0-14.6-.5c-8.4-.4-19.5-1.1-30.6-1.8 2.8-4.9 5.3-9.7 7.6-14.6 1.4-2.9 2.6-5.7 3.8-8.5 11.2-2.5 22.1-5.2 30.3-7.5 8.4-2.3 13.9-4.1 13.8-4.2 0 0-5.7 1.6-14.2 3.5-7.9 2.5-18.5 4.8-29.1 7.2Z",
    fill: "#0B4A1A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.6 57.8C18.5 28.9 34.8 0 34.8 0s28.1 17.5 14.8 57.8ZM63.1 77.6c-8.1-38.7 19.7-52 19.7-52s12.1 28.4-19.7 52ZM51.1 80.2C12 86.6 0 58.1 0 58.1s29-10.7 51.1 22.1ZM64.6 105.7c-38.1 18.9-59.5-6.5-59.5-6.5s26.3-20.3 59.5 6.5ZM81.2 129.3c-34.8 29.2-63.3 8.1-63.3 8.1s22.3-27.5 63.3-8.1ZM77.4 99.5c1.7-42.1 34-48.6 34-48.6s5 32.6-34 48.6ZM94.2 121.1c6.6-47.3 44.8-46.5 44.8-46.5s2.3 38.1-44.8 46.5ZM114.1 142.2c10.6-46.6 48.5-42.5 48.5-42.5s-.9 38.1-48.5 42.5Z",
    fill: "#02691A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.6 162.9c6.1-47.4 44.3-47 44.3-47s2.7 38.1-44.3 47ZM101.8 151c-27.4 36.2-59.9 22.1-59.9 22.1s15.5-31.8 59.9-22.1ZM126 173.5c-26.9 36.6-59.6 22.9-59.6 22.9s15.1-32 59.6-22.9Z",
    fill: "#02691A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.9 105c-4-6.4-7.5-12.8-10.5-18.9-.2-.5-.5-1-.7-1.5-10.9-4.2-21.4-8.6-29.3-12.2-8-3.5-13.1-6.2-13.1-6.2s5.4 2.4 13.5 5.6c7.7 3 17.8 6.9 28 10.9C51 65.9 46.9 50.8 44.7 40.1c-1.2-5.7-1.9-10.3-2.3-13.4-.4-3.1-.5-4.7-.5-4.7s.2 1.7.7 4.8c.5 3.1 1.3 7.7 2.6 13.5 2.5 10.7 6.9 25.6 15 42.1 3.8-9.6 7.6-18.9 10.5-25.9l5-12.2s-1.7 5.1-4.4 12.6S64.9 74.3 61 84.1c.3.7.7 1.3 1 2 3.1 6.1 6.7 12.3 10.8 18.6 6-9.1 12.1-17.9 16.8-24.5 4.9-6.9 8.3-11.2 8.3-11.2s-3.2 4.7-7.8 11.8c-4.5 6.9-10.4 16.1-16.4 25.2 1.7 2.6 3.5 5.2 5.4 7.8 3 4.1 6.2 8.2 9.6 12.3 7.5-7.8 15.1-15.4 20.8-21 6-5.9 10.1-9.6 10.2-9.6 0 0-4 4-9.8 10.2-5.6 5.9-12.9 13.7-20.3 21.5 4 4.8 8.3 9.5 12.9 14.2 1.8 1.8 3.6 3.6 5.5 5.4 8.2-7.2 16.4-14.1 22.6-19.3 6.5-5.3 10.9-8.7 10.9-8.7s-4.3 3.7-10.6 9.3c-6 5.4-13.9 12.5-21.9 19.6 7 6.7 14.5 13.1 22.5 19.1.7.5 1.4 1.1 2.1 1.6 7.6-8.1 15.2-15.9 21.1-21.7 5.9-5.9 10-9.7 10.1-9.7 0 0-3.9 4.1-9.7 10.3-5.6 6-12.9 14-20.3 22 4.2 3.1 8.5 6.1 12.9 8.9 2.8 1.8 5.6 3.5 8.5 5.2 1.4.8 2.9 1.7 4.3 2.4l2.2 1.2 1.1.6.5.3.3.1h.1c-.1.3-.4 1-.4 1.3v.1l-.3 1.4s-.3-.1-.2-.1h-.1l-.2-.1-.3-.1-.6-.3-1.2-.6c-.8-.4-1.5-.8-2.3-1.2-1.5-.8-3-1.7-4.5-2.5-3-1.7-5.9-3.5-8.7-5.4-4.6-3-9.2-6.2-13.5-9.5-10.4 5.2-20.9 10.1-28.8 13.5-8 3.5-13.4 5.5-13.4 5.5s5.4-2.3 13.2-6.2C111 180.1 121 175 131 170c-.6-.4-1.2-.9-1.7-1.3-8.1-6.2-15.6-12.8-22.7-19.6-10.6 4.2-21.1 8.1-29 10.9-8.2 2.9-13.8 4.4-13.8 4.4s5.6-1.9 13.7-5.1c7.7-3 17.8-7.1 28-11.2-1.9-1.8-3.7-3.7-5.5-5.5-4.4-4.6-8.5-9.2-12.3-13.9-11.3 2.6-22.5 4.8-30.9 6.3-8.6 1.5-14.3 2.2-14.3 2.2s5.8-1 14.3-2.9c8.2-1.8 19.1-4.3 29.9-6.8-3.5-4.4-6.8-8.7-9.9-13.1-1.8-2.6-3.5-5.2-5.2-7.8-11.5-.6-22.7-1.5-31.1-2.4-8.7-.9-14.3-1.8-14.3-1.8s5.8.6 14.6 1.1c8.4.4 19.2.9 30.1 1.5Z",
    fill: "#0B4A1A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m335.7 189.8-.7 4.6s-.3 3 3.4 3.4c3.7.3 5.1-2.2 6.2-4 1.1-1.8 3.8-5.5 6.8-6 2.9-.5 8.5-5.3 7.3-8.2-1.1-2.6-7.4-3.5-13.6.6v1.7s0 4.1-3.4 5.8c-3.4 1.7-6 2.1-6 2.1Z",
    fill: "#25228C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.4 187.8c-2.9.5-5.7 4.2-6.8 6-1.1 1.8-2.5 4.3-6.2 4-2.6-.2-3.3-1.8-3.4-2.7V196c0 .2.1.4.2.6l.5 1.6c1.8 1.6 4.5 1.7 6.6.2 2.1-1.5 3.8-5 3.8-5v-.9c1.4-1.7 3.3-3.5 5.3-3.9 2.8-.5 7.9-4.8 7.4-7.7-.4 2.9-4.8 6.5-7.4 6.9Z",
    fill: "#25228C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.8 178.9s3.4 14.2-12.8 16.5l-5.6-23.3 13-8.9c0-.1 2.8 13.2 5.4 15.7Z",
    fill: "#0B53FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.7 186.3c-3.9.5-7 2.9-11.6.7 0 0-2.6 3.8-10 5.1l-.9 3s-.8 2.4-.3 5.6c0 0 1.9 3.2 6.4 1.9 4.5-1.3 5.5-2.9 11.1-3.1 4.9-.1 11.7-3.4 13.1-8.1 1.4-4.6-3.5-5.7-7.8-5.1Z",
    fill: "#25228C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.7 190.3c0 .3-.1.7-.2 1.1-1.4 4.6-8.2 7.9-13.1 8.1-5.6.2-6.6 1.8-11.1 3.1s-6.4-1.9-6.4-1.9v1.6s1 2.4 4.3 2.4c3.3-.1 8.5-2.6 8.5-2.6V201c1.2-.4 2.6-.6 4.6-.7 4.9-.1 11.7-3.4 13.1-8.1.3-.7.4-1.3.3-1.9Z",
    fill: "#25228C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m363.7 150.7 2.1 3.9s-4.1 19.9 2.9 33.5c0 0-1.4 11.4-16.7 12.5 0 0-3.1-13-2.7-20 .3-7-.7-21.4-.7-21.4l15.1-8.5Z",
    fill: "#1F74FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 169.9c-6.9 4-6.9 10.6 0 14.6l52.4 30.3c6.9 4 18.3 4 25.2 0l52.4-30.3c6.9-4 6.9-10.6 0-14.6l-52.4-30.3c-6.9-4-18.3-4-25.2 0l-52.4 30.3Z",
    fill: "#279AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.3 177.7c.2 2.5 1.9 4.9 5.2 6.8l52.4 30.3c6.9 4 18.3 4 25.2 0l52.4-30.3c3.5-2 5.2-4.6 5.2-7.3v69.6c0 2.6-1.7 5.3-5.2 7.3l-52.4 30.3c-6.9 4-18.3 4-25.2 0l-52.4-30.3c-3.5-2-5.2-4.6-5.2-7.3v-69.1Z",
    fill: "#0045D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.3 147.5s-25.5 13.3-31.3 17.1c-5.8 3.8-9.8 17.1-21 12.1-14.9-6.6-13.7-14-11.3-22.3l12.8-5.7s16.5-3.4 27.8-8 17.2-5.9 20.1-2.4c2.8 3.6 2.9 9.2 2.9 9.2Z",
    fill: "#0B53FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.8 154.7s-25.5 13.3-31.3 17.1c-5.8 3.8-10.7 10.2-22.9 8.9-12.2-1.4-11.8-10.8-9.4-19.1l12.8-5.7s16.5-3.4 27.8-8 17.2-5.9 20.1-2.4c2.8 3.6 2.9 9.2 2.9 9.2Z",
    fill: "#1F74FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m307.1 132.2 23.1-13.4c.3-.2.8-.2 1.1 0l35.3 20.4c.2.1.2.2.2.3v1.1c0 .1-.1.2-.2.3l-23.1 13.4c-.3.2-.8.2-1.1 0l-35.3-20.4c-.2-.1-.2-.2-.2-.3v-1.1c0-.1.1-.2.2-.3Z",
    fill: "#005FF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M307.1 132.2c-.3.2-.3.5 0 .7l35.3 20.4c.3.2.8.2 1.1 0l23.1-13.4c.3-.2.3-.5 0-.7l-35.3-20.4c-.3-.2-.8-.2-1.1 0l-23.1 13.4Z",
    fill: "#279AFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.9 127.8c-.2.1-.2.2 0 .3l32.8 18.9c.2.1.4.1.6 0l9.8-5.7c.2-.1.2-.2 0-.3l-32.8-18.9c-.2-.1-.4-.1-.6 0l-9.8 5.7ZM319.2 137.6c-.3.2-.3.5 0 .7l7.7 4.4c.3.2.8.2 1.1 0l5.4-3.1c.3-.2.3-.5 0-.7l-7.7-4.4c-.3-.2-.8-.2-1.1 0l-5.4 3.1Z",
    fill: "#003AA5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M327.6 127c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM329.4 128c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM331.2 129.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM333 130.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM334.8 131.2c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM336.6 132.2c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM338.5 133.3c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM340.3 134.3c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM342.1 135.4c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM343.9 136.4c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM345.7 137.5c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM347.5 138.5c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM350 139.9c-.1.1-.3.1-.4 0l-1.6-.9c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.6.9c.1.1.1.2 0 .2l-1.1.6ZM326.9 124.5c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM328.7 125.6c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM330.3 124.4c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM328.5 123.3c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM332 125.3c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM333.6 126.3c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM335.3 127.3c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM337 128.2c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM338.6 129.2c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM340.3 130.1c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM341.9 131.1c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM343.6 132c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM345.3 133c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM346.9 134c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM348.6 134.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM350.3 135.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM352 136.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM353.6 137.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM355.2 138.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM356.9 139.7c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM358.5 140.7c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.5-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.5.3ZM360.2 141.6c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l.6-.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-.6.3ZM330.5 126.6c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM332.3 127.6c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM334.1 128.7c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM335.9 129.7c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM337.7 130.8c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM339.6 131.8c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM341.4 132.9c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM343.2 133.9c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM345 135c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM346.8 136c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM348.7 137.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM353.4 139.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM355 140.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM356.7 141.7c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM358.3 142.7c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM351.6 140.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM353.2 141.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM354.9 142.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM349.9 141.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM351.5 142.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM353.1 143.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM354.8 144.7c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l2.8-1.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-2.8 1.6ZM348 142.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM346.5 141.9c-.1.1-.2.1-.3 0l-.8-.5c-.1-.1-.1-.1 0-.2l1-.6c.1-.1.2-.1.3 0l.8.5c.1.1.1.1 0 .2l-1 .6ZM344.7 143c-.1.1-.2.1-.3 0l-.8-.5c-.1-.1-.1-.1 0-.2l1-.6c.1-.1.2-.1.3 0l.8.5c.1.1.1.1 0 .2l-1 .6ZM343.1 142c-.1.1-.2.1-.3 0l-.8-.5c-.1-.1-.1-.1 0-.2l1-.5c.1-.1.2-.1.3 0l.8.5c.1.1.1.1 0 .2l-1 .5ZM346.2 143.9c-.1.1-.2.1-.3 0l-.8-.5c-.1-.1-.1-.1 0-.2l1-.6c.1-.1.2-.1.3 0l.8.5c.1.1.1.1 0 .2l-1 .6ZM349.7 143.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM351.3 144.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM347.9 144.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM349.5 145.9c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-1.1.6ZM351.2 146.8c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l2.9-1.7c.1-.1.3-.1.4 0l.9.5c.1.1.1.2 0 .2l-2.9 1.7ZM351.8 138.9c-.1.1-.3.1-.4 0l-2.4-1.4c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l2.4 1.4c.1.1.1.2 0 .2l-1.1.6ZM326.2 128.2c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM328 129.3c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM329.9 130.3c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM331.7 131.4c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM333.5 132.4c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM335.3 133.5c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM337.1 134.5c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM338.9 135.6c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM340.7 136.6c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM342.6 137.7c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM344.4 138.7c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM348.2 140.9c-.1.1-.3.1-.4 0l-3.1-1.8c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l3.1 1.8c.1.1.1.2 0 .2l-1.1.6ZM325.3 129.8c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM325.7 125.9c-.1.1-.3.1-.4 0l-1.8-1c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.8 1c.1.1.1.2 0 .2l-1.1.6ZM324.4 127.2c-.1.1-.3.1-.4 0l-2.2-1.3c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l2.2 1.3c.1.1.1.2 0 .2l-1.1.6ZM323.5 128.7c-.1.1-.3.1-.4 0L320 127c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l3.1 1.8c.1.1.1.2 0 .2l-1.1.5ZM327.1 130.9c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM328.9 131.9c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM321.7 129.8c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM319.9 128.7c-.1.1-.3.1-.4 0l-1.3-.7c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.3.7c.1.1.1.2 0 .2l-1.1.6ZM323.5 130.8c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM325.6 132c-.1.1-.3.1-.4 0l-1.4-.8c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.4.8c.1.1.1.2 0 .2l-1.1.6ZM334.1 137c-.1.1-.3.1-.4 0l-7.8-4.5c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l7.8 4.5c.1.1.1.2 0 .2l-1.1.6ZM330.8 132.9c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM332.6 134c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM334.4 135c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM336.2 136.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM338 137.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM339.8 138.2c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM341.7 139.2c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM335.9 138c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM337.8 139.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM339.6 140.1c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM341.4 141.2c-.1.1-.3.1-.4 0l-1.1-.6c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l1.1.6c.1.1.1.2 0 .2l-1.1.6ZM344.8 141.1c-.1.1-.3.1-.4 0l-2.5-1.4c-.1-.1-.1-.2 0-.2l1.1-.6c.1-.1.3-.1.4 0l2.5 1.4c.1.1.1.2 0 .2l-1.1.6Z",
    fill: "#279AFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m331.1 117.2 5.7-26.9c.1-.4.3-.6.5-.7l.7-.3c.2-.1.5 0 .8.1l34.3 18.5c.6.3 1 1.2.9 1.9l-5.9 28.2c-.1.3-.2.6-.5.7l-.7.3c-.2.1-.5.1-.8-.1L332 119.1c-.7-.3-1.1-1.2-.9-1.9Z",
    fill: "#005FF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M331.1 117.2c-.1.7.2 1.6.9 1.9l34.1 19.7c.6.4 1.3.1 1.4-.6l5.9-28.2c.1-.7-.2-1.6-.9-1.9l-34.3-18.5c-.6-.3-1.3 0-1.4.7l-5.7 26.9Z",
    fill: "#003AA5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.4 110c0-.1 0-.2-.1-.3l-32.7-17.6c-.1-.1-.2 0-.2.1l-5.3 25.1c0 .1 0 .2.1.3l32.5 18.7c.1.1.2 0 .2-.1l5.5-26.2Z",
    fill: "#2075FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.3 110s.7-5.6 2.1-6.3c1.3-.7 4.2.2 5-.5.8-.7 1.7-3.6 2.2-4.4.5-.8 1.9-3.3 2.1-4.5.2-1.3-.2-2 .5-3s1.3-6 .7-8.4c-.5-2.4-4.5-8.3-12.6-7.9-8.1.4-12.1 6.8-12.4 11.4-.2 4.6 1.7 10.2.3 13.1-1.5 2.9-2.9 5.1-5.5 6 0 0-4 4.4 6.4 7 10.5 2.5 11.2-2.5 11.2-2.5Z",
    fill: "#FFCDA8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.8 72.5c-11.2-.9-15.1 8-15.3 11.2-.2 3.2.8 7.9.8 7.9.2 1.8.5 3.6.5 5.1.8.8 2.1 1.8 3.8 2.3 3 .9 6.6.8 7.3-.8.7-1.6 1.4-5.3 3.3-6 1.8-.7 3.6 1.2 3.6 1.2l.6-.5s.7-3.2 1.8-3.9c1-.7 1.9-1.9 1.8-2.8-.1-.8-.1-3.1 1.9-3.8 0 0 .8.2 1.5-2 .6-2.1-2.3-7.1-11.6-7.9Z",
    fill: "#2075FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.5 103c-1.4-1.2-3.6-3.4-3.9-5.9-.2-2.4-.1-4.1.1-5-.2 0-.4.1-.6.1-1.8.7-2.6 4.4-3.3 6-.1.3-.4.6-.8.8-.4 4-1.1 9.8-1.8 13.7 2.7-.9 3-2.8 3-2.8s.7-5.6 2.1-6.3c1.3-.7 4.2.2 5-.5.1 0 .2 0 .2-.1Z",
    fill: "#D9A782"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.8 96.2v.6c.8.8 2.1 1.8 3.8 2.3 3 .9 6.6.8 7.3-.8.7-1.6 1.4-5.3 3.3-6 1.8-.7 3.6 1.2 3.6 1.2l.6-.5s.7-3.2 1.8-3.9c.4-.3.8-.7 1.2-1.1-2.6 1.7-9.2 4.6-11.8 5.2-2.9.7-7.4-.6-10.1-1.6.1 1.2.3 2.3.4 3.3-.1.5-.1.9-.1 1.3Z",
    fill: "#2075FE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.2 94.4s.6-1.8-.8-1.7c-1.4.1-2.3 2.8-1.6 4.5.8 1.7 1.5 1.7 1.8.1.4-1.7.6-2.9.6-2.9Z",
    fill: "#FFCDA8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m298.9 101.9-3.6-.2s-6.5-.9-9.4 1c-3 1.9-2.1 4.1-1.8 11.6.3 7.5 3.5 19 5.9 24.4 2.4 5.4 3.2 8.5 2.1 11.6-1.1 3.1-2 5.2-1.4 8.6.8 4.8 5 6.6 11.2 9.7 6.2 3 8.1 2.9 13 3.5 2.9.3 11.8 1 15-5.4 3.2-6.3 3.2-9.3 3.2-9.3s-5.3-6.2-7.3-15.1c-2-9-.7-23.4-.7-23.4s-6-5.7-7-6.7-5.7-3.6-5.7-3.6-14.9-.5-13.5-6.7Z",
    fill: "#FF3785"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8 145s.9-2.3 1.9-3.5c1-1.2 1.3-2.5 2.5-2.3h.9s5-1.7 6.7-1.7c1.7.1 4.4 3 5 3.7.6.7 1.6 1.7 1.4 2.8-.2 1.1.6 1.5-1.9 1.3-1.3-.1-1.9.4-3 1.1-1.1.7-4.5 2.7-9 4-4.6 1.5-4.5-5.4-4.5-5.4Z",
    fill: "#FFCDA8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M356.1 144.2c.2-1.1-.8-2.2-1.4-2.8-.3-.4-1.4-1.6-2.6-2.5H351c-1 .2-4 .9-4.2 1-.2 0-.6.7 0 1.2s1.2 1.5 1.2 1.9c0 .4 0 2.1-.3 2.6-.2.4-6.9 3.2-8.9 4.4.8.7 1.9 1.1 3.3.7 4.5-1.3 7.8-3.3 9-4 1.1-.7 1.7-1.2 3-1.1 2.6 0 1.7-.3 2-1.4Z",
    fill: "#D9A782"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M309.7 150.7c.5-2.1 1.9-5.9 1.6-7.4-.3-1.4-3-4-.7-7.5 2.4-3.5 3.1-6.9 3.1-6.9l11.1.4c0 4.2.3 9 1.1 12.7 2 9 7.3 15.1 7.3 15.1s0 3-3.2 9.3c-3.2 6.3-12.1 5.7-15 5.4-2.9-.3-4.7-.4-7-1.1 1.3-7.3 1.3-18.3 1.7-20Z",
    fill: "#D9115F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M328.1 134c-.5-3.5-.1-11.1-1.9-14.5-1.8-3.4-13.5-2.2-13.2 10.6.2 12.8.4 23.1 1.8 26.6 1.4 3.4 4.3 9.5 11 6.3s17.4-12.7 17.4-12.7l-4.7-6.5-11.2 4.6c-.1.1 1.4-10.5.8-14.4Z",
    fill: "#FF3785"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m101.2 117.2 214.3 123.7 6.1-2.5-214.4-123.8-6 2.6Z",
    fill: "#279AFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M315.5 426.5V240.9l6.1-2.5v185.5l-6.1 2.6Z",
    fill: "#279AFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M315.5 426.5 101.2 302.7V117.2l214.3 123.7v185.6Z",
    fill: "#7AB8FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M315.5 256.3 101.2 132.6v-15.4l214.3 123.7v15.4Z",
    fill: "#005FF1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M309.9 245.3c0-2.3-1.6-5.1-3.6-6.2-2-1.1-3.6-.2-3.6 2.1 0 2.3 1.6 5.1 3.6 6.2 2 1.2 3.6.2 3.6-2.1ZM298.4 238.7c0-2.3-1.6-5.1-3.6-6.2-2-1.1-3.6-.2-3.6 2.1 0 2.3 1.6 5.1 3.6 6.2 2 1.1 3.6.2 3.6-2.1ZM286.9 232.1c0-2.3-1.6-5.1-3.6-6.2-2-1.1-3.6-.2-3.6 2.1 0 2.3 1.6 5.1 3.6 6.2 2 1.1 3.6.2 3.6-2.1Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m181.1 334.5-67.8-39.1V152.2l67.8 39.2v143.1ZM306.3 334l-116.4-67.2v-70.4l116.4 67.2V334ZM306.3 407l-48.4-27.9v-66.5l48.4 27.9V407ZM251.1 375.1l-61.2-35.3v-66.5l61.2 35.3v66.5Z",
    fill: "#005FF1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.7 175.9 117.4 163v-1.6l22.3 12.9v1.6ZM163.9 189.9 141.6 177v-1.6l22.3 12.9v1.6Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m137.2 180.1-19.8-11.4v-1.6l19.8 11.4v1.6Z",
    fill: "#FC734A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m176.1 202.6-37.3-21.5v-1.6l37.3 21.5v1.6Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m136.9 185.7-11.9-6.9v-1.6l11.9 6.9v1.6ZM136.9 191.4l-11.9-6.9v-1.6l11.9 6.9v1.6Z",
    fill: "#01339E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m165.3 202.1-26.5-15.3v-1.6l26.5 15.3v1.6ZM150.8 199.4l-12-6.9v-1.6l12 6.9v1.6ZM175.4 219.3l-36.5-21.1v-1.6l36.5 21.1v1.6ZM163.9 218.4l-25-14.5v-1.6l25 14.5v1.6Z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m132.5 206-15.1-8.8v-1.6l15.1 8.8v1.6ZM132.5 211.7l-15.1-8.8v-1.6l15.1 8.8v1.6Z",
    fill: "#FC734A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m149.9 216-15.2-8.8v-1.6l15.2 8.8v1.6ZM163.9 229.8l-29.2-16.9v-1.6l29.2 16.9v1.6ZM175.4 242.1l-40.9-23.6v-1.6l40.9 23.6v1.6ZM157.2 237.3l-22.7-13.1v-1.6l22.7 13.1v1.6ZM148.8 238.2l-14.3-8.3v-1.6l14.3 8.3v1.6ZM170.6 256.5l-36.1-20.9v-1.5l36.1 20.8v1.6ZM142.3 245.8l-7.8-4.4v-1.6l7.8 4.4v1.6ZM159.1 261.2l-24.6-14.1v-1.6l24.6 14.1v1.6Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m136.9 254.1-11.9-6.8v-1.6l11.9 6.9v1.5Z",
    fill: "#01339E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m151.8 262.7-11.9-6.9v-1.6l11.9 6.9v1.6Z",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m132.5 257.3-15.1-8.7V247l15.1 8.7v1.6Z",
    fill: "#FC734A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m149.9 267.3-15.2-8.7V257l15.2 8.7v1.6ZM170.6 285l-36.1-20.9v-1.5l36.1 20.8v1.6ZM163.9 286.9l-29.4-17v-1.6l29.4 17v1.6ZM156.3 288.1l-21.8-12.5V274l21.8 12.5v1.6ZM163.9 298.3l-29.4-17v-1.6l29.4 17v1.6Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m134.5 292.7-17.1-9.9v-1.6l17.1 9.9v1.6Z",
    fill: "#FC734A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M174.2 315.6 136.8 294v-1.6l37.4 21.6v1.6Z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m136.9 299.8-11.9-6.9v-1.6l11.9 6.9v1.6Z",
    fill: "#01339E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m151.3 308.1-11.9-6.9v-1.6l11.9 6.9v1.6Z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M296.2 298.9c-6.8-3.9-6.3-30.5-18.3-37.5-12.1-7-13.3 27.4-21.1 22.9-7.8-4.5-7.6-29.7-17.5-35.4-9.9-5.7-9.7 23.8-17.7 19.1-8-4.6-9.7-26.2-17.9-30.9-8.1-4.7-11.1 9.3-13.8 7.7v22L306.3 334v-42.9s-3.3 11.7-10.1 7.8Z",
    fill: "#7AB8FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m210.3 236.7-10.5-6.1v-3.7l10.5 6v3.8ZM285.7 263.9l-10.5-6.1v-3.7l10.5 6v3.8Z",
    fill: "#FC734A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m248.1 251.7-10.5-6v-3.8l10.5 6.1v3.7Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m275.3 344.3-12.7-7.3v-14.3l12.7 7.4v14.2ZM302.6 347.8l-21.9-12.7v-1.9l21.9 12.6v2ZM246.9 316.6l-22-12.7V302l22 12.6v2ZM246.9 321.8l-22-12.7v-2l22 12.7v2ZM246.9 326.9l-22-12.6v-2l22 12.6v2ZM246.9 332.1l-22-12.7v-2l22 12.7v2ZM246.9 337.2l-22-12.6v-2l22 12.7v1.9ZM302.6 351.8l-24.5-14.2v-1.8l24.5 14.2v1.8ZM302.6 356l-24.5-14.2v-1.9l24.5 14.2v1.9ZM293.2 354.6l-15.1-8.7v-1.8l15.1 8.7v1.8ZM275.3 365.6l-12.7-7.3V344l12.7 7.3v14.3ZM302.6 369l-24.5-14.2v-1.9l24.5 14.2v1.9ZM302.6 373.1l-24.5-14.2v-1.8l24.5 14.1v1.9ZM302.6 377.2l-24.5-14.1v-1.9l24.5 14.2v1.8ZM293.2 375.9l-15.1-8.7v-1.9l15.1 8.8v1.8ZM275.3 384.9l-12.7-7.3v-14.3l12.7 7.3v14.3ZM302.6 388.2l-24.5-14.1v-1.9l24.5 14.2v1.8ZM246.9 348.3l-35.4-20.5V326l35.4 20.4v1.9ZM225.1 339.4l-13.6-7.8v-1.9l13.6 7.9v1.8ZM246.9 359.2l-35.4-20.4v-1.9l35.4 20.5v1.8ZM225.1 350.4l-13.6-7.9v-1.8l13.6 7.8v1.9ZM302.6 392.4l-24.5-14.2v-1.9l24.5 14.2v1.9ZM302.6 396.5l-24.5-14.2v-1.8l24.5 14.1v1.9ZM293.2 395.2l-15.1-8.7v-1.9l15.1 8.7v1.9Z",
    fill: "#7AB8FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 309.2c0-7.4-5.2-16.3-11.6-20-6.4-3.7-11.6-.7-11.6 6.7s5.2 16.3 11.6 20c6.5 3.7 11.6.7 11.6-6.7Z",
    fill: "#FC734A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M207 289.1v13.4l11.6 6.7c-.1-7.4-5.2-16.4-11.6-20.1Z",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 324.9c0-1.9-1.4-4.3-3-5.3-1.7-1-3-.2-3 1.8 0 1.9 1.4 4.3 3 5.3 1.6.9 3 .1 3-1.8ZM204.8 335.9c0-1.9-1.4-4.3-3-5.3-1.7-1-3-.2-3 1.8 0 1.9 1.4 4.3 3 5.3 1.6.9 3 .1 3-1.8Z",
    fill: "#FC734A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M470 345.9 255.7 469.7V284.1L470 160.4v185.5Z",
    fill: "#7AB8FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M470 175.8 255.7 299.5v-15.4L470 160.4v15.4Z",
    fill: "#005FF1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M464.4 171.3c0-2.3-1.6-3.2-3.6-2.1s-3.6 3.9-3.6 6.2c0 2.3 1.6 3.2 3.6 2.1s3.6-3.9 3.6-6.2ZM452.9 178c0-2.3-1.6-3.2-3.6-2.1s-3.6 3.9-3.6 6.2c0 2.3 1.6 3.2 3.6 2.1s3.6-3.9 3.6-6.2ZM441.4 184.6c0-2.3-1.6-3.2-3.6-2.1s-3.6 3.9-3.6 6.2c0 2.3 1.6 3.2 3.6 2.1s3.6-3.9 3.6-6.2Z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m461.1 336.7-67.8 39.2V232.7l67.8-39.1v143.1ZM383.8 308.6l-116.4 67.2v-70.4l116.4-67.2v70.4ZM383.8 383.1l-116.4 67.3v-67.9l116.4-67.2v67.8Z",
    fill: "#005FF1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 424.3-10.7-4.3.4-.7 10.3 4.2 11.8-17.1 8.1 1.4 8.6-15 14.9.4 15.1-26.1 9.7 5.6 10.3-22.6 9.6 5.5 17.6-33.6.4.2-18 34.3-9.5-5.5-10.3 22.7-9.8-5.7-15 25.9-14.9-.4-8.7 15.1-8.1-1.5-11.8 17.2Z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m277.7 428.1-10.4.3.2-.7 10.2-.3 11.6-15.3 8.5-.9 8.5-8.1 15-2.5 15.2-23.4 9.7-.8 11-11.2 8.2 3.1 18.3-26.1.3.4-18.6 26.6-8.3-3.2-10.9 11.1-9.6.8-15.2 23.3-15.1 2.6-8.5 8.1-8.4.9-11.7 15.3Z",
    fill: "#FC734A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m419.7 225.9-22.3 12.9v-1.6l22.3-12.9v1.6ZM444 211.9l-22.3 12.9v-1.6l22.3-12.9v1.6Z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m417.2 233-19.8 11.5v-1.6l19.8-11.5v1.6Z",
    fill: "#FC734A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m456.2 210.6-37.3 21.5v-1.6l37.3-21.5v1.6Z",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m417 238.9-12 6.9v-1.6l12-6.9v1.6ZM417 244.6l-12 6.9v-1.6l12-6.9v1.6Z",
    fill: "#01339E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m445.4 222.5-26.5 15.3v-1.6l26.5-15.3v1.6ZM430.8 236.6l-11.9 6.9v-1.6l11.9-6.9v1.6ZM455.5 228.1l-36.6 21.1v-1.6l36.6-21.1v1.6ZM444 240.4l-25.1 14.5v-1.6l25.1-14.5v1.6Z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m412.6 264.2-15.2 8.8v-1.6l15.2-8.8v1.6ZM412.6 270l-15.2 8.7v-1.6l15.2-8.7v1.6Z",
    fill: "#FC734A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m429.9 254.2-15.2 8.8v-1.6l15.2-8.7v1.5ZM444 251.8l-29.3 16.9v-1.6l29.3-16.9v1.6ZM455.5 250.9l-40.9 23.6v-1.6l40.9-23.6v1.6ZM437.2 267.2l-22.6 13v-1.6l22.6-13v1.6ZM428.8 277.7l-14.2 8.2v-1.6l14.2-8.2v1.6ZM450.7 270.8l-36.1 20.8V290l36.1-20.8v1.6ZM422.3 292.9l-7.7 4.4v-1.6l7.7-4.4v1.6ZM439.2 288.8 414.6 303v-1.6l24.6-14.1v1.5Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m417 307.4-12 6.8v-1.6l12-6.8v1.6Z",
    fill: "#01339E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m431.9 298.8-12 6.9v-1.6l12-6.9v1.6Z",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m412.6 315.6-15.2 8.8v-1.6l15.2-8.8v1.6Z",
    fill: "#FC734A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m429.9 305.6-15.2 8.8v-1.6l15.2-8.8v1.6ZM450.7 299.3l-36.2 20.9v-1.6l36.2-20.9v1.6ZM444 308.9l-29.5 17v-1.6l29.5-17v1.6ZM436.3 319l-21.8 12.6V330l21.8-12.6v1.6ZM444 320.3l-29.5 17v-1.6l29.5-17v1.6Z",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m414.5 348.7-17.1 9.9V357l17.1-9.9v1.6Z",
    fill: "#FC734A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m454.2 325.8-37.3 21.6v-1.6l37.3-21.6v1.6Z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m417 353-12 6.9v-1.6l12-6.9v1.6Z",
    fill: "#01339E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m431.4 344.7-12 6.9V350l12-6.9v1.6Z",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m296.1 420.8-10.4 6v-3.7l10.4-6v3.7ZM368.1 377.7l-10.5 6.1v-3.7l10.5-6.1v3.7Z",
    fill: "#FC734A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m296.5 397.7-10.5 6.1v-3.7l10.5-6.1v3.7ZM341.6 360.3l-10.5 6v-3.7l10.5-6v3.7Z",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M379.7 253.8 362 264v-1.9l17.7-10.2v1.9ZM375.6 259.9l-13.6 7.8v-1.8l13.6-7.9v1.9Z",
    fill: "#7AB8FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M358.4 267c0-1.9-1.4-2.7-3-1.8-1.7 1-3 3.3-3 5.3 0 1.9 1.4 2.7 3 1.8 1.6-1 3-3.3 3-5.3Z",
    fill: "#FC734A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M379.7 266 362 276.2v-1.9l17.7-10.2v1.9ZM375.6 272.1l-13.6 7.8v-1.8l13.6-7.9v1.9Z",
    fill: "#7AB8FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M358.4 279.2c0-1.9-1.4-2.7-3-1.8-1.7 1-3 3.3-3 5.3 0 1.9 1.4 2.7 3 1.8 1.6-1 3-3.3 3-5.3Z",
    fill: "#FC734A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M379.7 278.2 362 288.4v-1.9l17.7-10.2v1.9ZM375.6 284.3l-13.6 7.8v-1.8l13.6-7.9v1.9Z",
    fill: "#7AB8FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M358.4 291.4c0-1.9-1.4-2.7-3-1.8-1.7 1-3 3.3-3 5.3 0 1.9 1.4 2.7 3 1.8 1.6-1 3-3.3 3-5.3Z",
    fill: "#FC734A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M379.7 290.4 362 300.6v-1.9l17.7-10.2v1.9ZM375.6 296.5l-13.6 7.8v-1.8l13.6-7.9v1.9Z",
    fill: "#7AB8FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M358.4 303.6c0-1.9-1.4-2.7-3-1.8-1.7 1-3 3.3-3 5.3 0 1.9 1.4 2.7 3 1.8 1.6-1 3-3.3 3-5.3Z",
    fill: "#FC734A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m284 306.1-9.8 5.6v53.6l9.8-5.6v-53.6ZM295.8 326.9l-9.8 5.6v26l9.8-5.6v-26ZM307.6 307.8l-9.8 5.6v38.3l9.8-5.6v-38.3ZM319.3 306.7l-9.7 5.6v32.6l9.7-5.6v-32.6ZM331.1 295l-9.7 5.6v37.5l9.7-5.6V295ZM342.9 279.8l-9.7 5.6v45.9l9.7-5.6v-45.9Z",
    fill: "#7AB8FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M470 345.9 255.7 469.7V284.1L470 160.4v185.5Z",
    fill: "url(#a)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M470 160.4 255.7 284.1l-6-2.5L464 157.8l6 2.6Z",
    fill: "#279AFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m203 360.2-7.6 1.8-5.8 4.9 11.1 14.6 2.3-21.3ZM228.7 374.7s6.2 8.8 6.2 14.1c0 5.3-27 6.3-27 6.3l-3.2-30 24 9.6Z",
    fill: "#008389"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 376.6c.1-1.2.2-1.9.2-1.9s-14.4-7.8-22.6-10.8c-8.2-3-19.4-6-23.9-4.8-4.5 1.2-7.6 5.8-3.3 11.7 4.3 5.9 30.2 37.4 30.2 37.4l13.2-8.4-12.6-15s11.2 9 13.9 10.9c.3.2.5.1.8-.1l.1.1c2 1.6 13.4 2.6 13.7 2.4.3-.2 12.9-13.8 12.9-13.8l-22.6-7.7Z",
    fill: "#004F49"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M197.8 402.8s-.7 1.9-2.8 3.3c-2.1 1.4-6.4 3.3-6.4 3.3s-.7 3.1-1.8 4.6c-1.1 1.6-4.5 6.2-5 7.4-.5 1.2-.4 2.1.8 3.2 0 0 .6 1.3 1.8 1.3 1.3 0 4.6-1.2 7-3.2 2.4-2 4.2-5.6 5.8-6.6l.9.6s5.4-4.1 6.3-5.5c.9-1.3 1.4-2.7.9-3.2-.5-.5-1.8-1.4-1.8-1.4s-2.9-3.1-5.7-3.8Z",
    fill: "#25228C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M184.4 426c1.3 0 4.6-1.2 7-3.2 2.4-2 4.2-5.6 5.8-6.6l.9.6s5.4-4.1 6.3-5.5c.9-1.3 1.4-2.7.9-3.2-.5-.5-1.8-1.4-1.8-1.4l-.2-.2c-.9.3-2.6 1.1-4.6 2.7-1.8 1.5-1.7 1.8-5.2 4.4-3.4 2.7-7.8 5.6-9.1 7-1.6 1.7-1.9 2.6-1.8 4.1-.1 0 .5 1.3 1.8 1.3Z",
    fill: "#25228C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M205.3 408c-.1 0-.1 0 0 0-.6-.1-1.3.1-2.3.6-2.2 1.1-4.1 2.8-4.1 2.8l-1-.4s-3.7 2.9-5.3 4c-1.6 1.2-6 4.6-7.3 6-1.1 1.2-2.3 3.2-1.6 4.8.2.1.4.1.7.2 1.3 0 4.6-1.2 7-3.2 2.4-2 4.2-5.6 5.8-6.6l.9.6s5.4-4.1 6.3-5.5c.9-1.4 1.4-2.8.9-3.3Z",
    fill: "#00005A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8 397.7c-1.4 0-7.3 1.2-9.3 1.8-2 .6-9.2 2.8-10.5 3.5-1.3.7-4.3 2.1-3.8 5.3.5 3.2 4.3 4.4 8.1 4.7 3.7.3 8.5-1.7 10.7-2.8 2.2-1.1 5.3-2.3 6.8-2.9 1.5-.5 5-1.5 5.6-3.9.6-2.4-.1-4.7-1.9-5.3-1.8-.7-5.7-.4-5.7-.4Z",
    fill: "#25228C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3 396.9s-3.7 3-2.8 7.3c.8 4.2 4 6.1 10 6 6-.2 27.9-1.9 36.2-2.7 8.3-.9 12.5-5.5 14.3-8.4 1.8-2.8 0-11.5 0-11.5s-4.7-4.2-12.2-3.2c-7.5 1.1-9.7 7.9-9.7 7.9s-14.5.5-35.8 4.6Z",
    fill: "#008389"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M216.2 300.9s1.3 5.7 6.4 9.2c0 0-2.9 13.5-7.7 14.4-4.8 1-14.8 1.5-13.3-8.8s14.6-14.8 14.6-14.8Z",
    fill: "#D9A782"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M215 324.5c.2 0 .4-.1.6-.2-1.2-2.7-2.1-7.1-.1-13.8 1.3-4.3-1.3-6.1-5.2-6.6-3.7 2.4-7.8 6.2-8.6 11.8-1.5 10.2 8.5 9.7 13.3 8.8Z",
    fill: "#CC9A75"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M223.2 310.1c-.3-.1-.6-.3-.9-.4-.6 6.8-8.7 15.1-14.2 13.9-5.6-1.2-2.7-8.3-2.7-8.3s.2-2.9.5-6.4c-1.5.3-2.3.6-2.3.6s-2.9 4.9-4.4 13.6c-1.4 8.7 1.6 14.1 1.6 14.1s.7 11.5-.7 14.5-5 8.6-5 8.6-3.4 6.4 10.4 10.2c13.7 3.7 22.7 4 22.7 4s.3-6.6 1-12.5 5.4-17.7 5.4-17.7l2.4-22c0-.1-4.5-7.9-13.8-12.2Z",
    fill: "#FE769C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M236 331.3h-9s-2.7 2.3-1.4 4.6c1.3 2.3.1 6.2-3.3 6.9-3.4.7-5.4.5-3.8 2.5 1.6 2-.1 16.4-2.7 18.2-2.7 1.8-8.4 4.4-8.4 4.4s-.3 1.2-.6 2.9c13 3.4 21.4 3.7 21.4 3.7s.3-6.6 1-12.5 5.4-17.7 5.4-17.7l1.4-13Z",
    fill: "#FF2363"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m222.3 382.1-37.7-21.8c-.3-.2-.9-.2-1.2 0l-24.7 14.3c-.2.1-.3.2-.2.4v.8c0 .1.1.3.2.3l37.7 22.1c.3.2.9.2 1.2 0l24.7-14.3c.2-.1.2-.2.2-.3v-1.1c0-.1 0-.3-.2-.4Z",
    fill: "#005FF1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M183.4 360.4c.3-.2.9-.2 1.2 0l37.7 21.8c.3.2.3.5 0 .7l-24.7 14.3c-.3.2-.9.2-1.2 0l-37.7-21.8c-.3-.2-.3-.5 0-.7l24.7-14.3Z",
    fill: "#279AFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M175.3 367c.2-.1.4-.1.6 0l35 20.2c.2.1.2.3 0 .3l-10.5 6.1c-.2.1-.4.1-.6 0l-35-20.2c-.2-.1-.2-.3 0-.3l10.5-6.1Z",
    fill: "#000675"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M200.1 371.7c.3-.2.9-.2 1.2 0l8.2 4.7c.3.2.3.5 0 .7l-5.8 3.3c-.3.2-.9.2-1.2 0l-8.2-4.7c-.3-.2-.3-.5 0-.7l5.8-3.3Z",
    fill: "#005FF1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m203.8 374.9 1.4-.8-4-2.3c-.3-.2-.7-.2-1 0l-.9.5 4.5 2.6Z",
    fill: "url(#b)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M200.5 388.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#c)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M198.6 387.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#d)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M196.6 386.1c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#e)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M194.7 385c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#f)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M192.8 383.9c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#g)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M190.8 382.8c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#h)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M188.9 381.7c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#i)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M187 380.5c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#j)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M185 379.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#k)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M183.1 378.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#l)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.1 377.2c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#m)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M179.2 376.1c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#n)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M176.6 374.6c.1-.1.3-.1.4 0l1.7 1c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.7-1c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#o)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M201.3 391c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#p)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M199.3 389.9c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#q)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M197.6 391.2c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#r)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 392.3c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#s)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M195.8 390.1c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#t)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M194 389.1c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#u)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M192.3 388.1c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#v)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 387.1c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#w)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7 386.1c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#x)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9 385c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#y)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M185.2 384c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#z)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M183.4 383c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#A)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 382c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#B)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8 380.9c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#C)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M178.1 379.9c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#D)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M176.2 378.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.4c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.4Z",
    fill: "url(#E)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 377.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#F)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 376.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#G)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M171 375.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#H)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M169.2 374.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#I)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 373.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#J)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M165.7 372.8c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-.6.3c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l.6-.3Z",
    fill: "url(#K)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M197.4 388.8c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#L)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 387.7c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#M)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 386.6c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#N)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6 385.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#O)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M189.6 384.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#P)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M187.7 383.2c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#Q)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M185.8 382.1c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#R)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M183.8 381c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#S)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M181.9 379.8c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#T)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M180 378.7c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#U)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M178 377.6c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#V)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M172.9 374.7c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#W)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M171.2 373.7c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#X)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 372.7c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#Y)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M167.7 371.7c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#Z)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9 373.6c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aa)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M173.1 372.6c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ab)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4 371.6c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ac)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M176.7 372.5c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ad)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M175 371.5c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ae)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M173.2 370.5c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#af)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 369.5c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-3 1.8c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l3-1.8Z",
    fill: "url(#ag)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M178.7 371.4c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ah)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M180.3 372.4c.1-.1.3-.1.4 0l.9.5c.1.1.1.1 0 .2l-1 .6c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.1 0-.2l1-.6Z",
    fill: "url(#ai)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M182.2 371.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.1 0 .2l-1 .6c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.1 0-.2l1-.6Z",
    fill: "url(#aj)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M184 372.3c.1-.1.3-.1.4 0l.9.5c.1.1.1.1 0 .2l-1 .6c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.2 0-.2l1-.6Z",
    fill: "url(#ak)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M180.6 370.4c.1-.1.3-.1.4 0l.9.5c.1.1.1.1 0 .2l-1 .6c-.1.1-.3.1-.4 0l-.9-.5c-.1-.1-.1-.1 0-.2l1-.6Z",
    fill: "url(#al)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M176.9 370.4c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#am)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 369.4c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#an)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8 369.3c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ao)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M177.1 368.3c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ap)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M175.3 367.2c.1-.1.3-.1.4 0l1 .6c.1.1.1.2 0 .2l-3.1 1.8c-.1.1-.3.1-.4 0l-1-.6c-.1-.1-.1-.2 0-.2l3.1-1.8Z",
    fill: "url(#aq)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M174.7 375.7c.1-.1.3-.1.4 0l2.5 1.5c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-2.5-1.5c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ar)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M201.9 387.1c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#as)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M200 385.9c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#at)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M198.1 384.8c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#au)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1 383.7c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#av)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M194.2 382.6c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aw)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M192.3 381.5c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ax)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M190.3 380.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ay)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M188.4 379.2c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#az)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M186.4 378.1c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aA)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 377c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aB)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M182.6 375.9c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aC)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 373.5c.1-.1.3-.1.4 0l3.3 1.9c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-3.3-1.9c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aD)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M202.9 385.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aE)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 389.5c.1-.1.3-.1.4 0l1.9 1.1c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.9-1.1c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aF)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9 388.2c.1-.1.3-.1.4 0l2.3 1.3c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-2.3-1.3c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aG)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M204.9 386.5c.1-.1.3-.1.4 0l3.3 1.9c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-3.3-1.9c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aH)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M201 384.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aI)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M199 383.1c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aJ)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8 385.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aK)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M208.7 386.5c.1-.1.3-.1.4 0l1.4.8c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.4-.8c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aL)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 384.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aM)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M202.6 383c.1-.1.3-.1.4 0l1.5.8c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.4-.8c-.1-.1-.1-.2 0-.2l1.1-.7Z",
    fill: "url(#aN)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 377.7c.1-.1.3-.1.4 0l8.3 4.8c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-8.3-4.8c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aO)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M197.1 382c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aP)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M195.2 380.9c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aQ)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M193.2 379.8c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aR)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M191.3 378.7c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aS)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M189.3 377.6c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aT)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M187.4 376.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aU)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 375.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aV)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6 376.6c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aW)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M189.6 375.5c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aX)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M187.7 374.4c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aY)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M185.8 373.3c.1-.1.3-.1.4 0l1.2.7c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-1.2-.7c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#aZ)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M182.1 373.4c.1-.1.3-.1.4 0l2.6 1.5c.1.1.1.2 0 .2l-1.2.7c-.1.1-.3.1-.4 0l-2.6-1.5c-.1-.1-.1-.2 0-.2l1.2-.7Z",
    fill: "url(#ba)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M185.1 363.7c.2.1 1.9 1.4 1.7 2.1-.3.7-.9 4.7-.4 5 .5.3 2-.1 2.7-3 .7-3 .7-4.2.3-5.4-.4-1.1-2.3-3.5-1.1-4.7 1.2-1.2 6.8-5.2 6.8-5.2l-7.7-4.2s-2.4 3-3.7 5.5c-1.3 2.5-3.5 4.2-3.7 4.4-.1.1-3.5 2.1-4.5 4.7s-1.7 5.7-1.7 6.8c0 1.1.3 2.2.6 2.3.3.1.8.3 1.9.9 1.1.6 1.1.7 2.2.4 1.1-.2 2.2-.6 2.8-1.4.6-.8.7-3.4 2-5.6 1.2-2.3 1-2.8 1.8-2.6Z",
    fill: "#FFCDA8"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m195 352.5-2.6-1.4c-2 1.9-5.8 5.6-6.2 6.9-.4 1.3 1.8 3.7 3.4 5.2-.1-.3-.1-.5-.2-.7-.4-1.1-2.3-3.5-1.1-4.7 1-1.3 6.7-5.3 6.7-5.3Z",
    fill: "#D9A782"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M210 368.3c-.8 0-5.1-1.1-6.9-1.3-1.8-.2-3-.2-5.4.6-2.4.9-3.3 1.3-4.2 2.2-1 .9-2.5 2.8-3 3.4-.5.6-.5 1.3.9 1.1 0 0-.9 1.6-.9 2.2 0 .6.6 1 2.2.6 0 0-.9 1.6-.1 1.8.7.3 1.5-.1 2.3-.8.8-.8 2.9-2.6 4-2.9 1.1-.4 2.2-.6 2.2-.6l-2.8 2.8c-.8.8-2.3 3.3-1.8 3.6.5.3 1.3.4 2.5-1.3 1.2-1.7 3.8-2.8 4.2-2.8.4 0 3.8 0 5.7-.5 1.9-.6 3.3-2.3 4.1-2.3.8-.1 12.6-3.3 12.6-3.3l-3.6-7.2-12 4.7Z",
    fill: "#FFCDA8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M224.7 369c-1.7.5-8.3 2.7-9.6 3-1.4.4-2.2-1.1-4.1 0-1.9 1.1-2.7 2.2-4.2 2.9-1.6.7-4.9 1.2-6.7 2.8-1 .9-2 2.3-2.6 3.4.4-.1 1-.5 1.6-1.4 1.2-1.7 3.8-2.8 4.2-2.8.4 0 3.8 0 5.7-.5 1.9-.6 3.3-2.3 4.1-2.3.8-.1 12.6-3.3 12.6-3.3l-1-1.8ZM196.8 375.5c-1.4 1.2-2.7 2.7-3.7 3.6.6 0 1.2-.4 1.8-.9.8-.8 2.9-2.6 4-2.9 1.1-.4 2.2-.6 2.2-.6l.6-.8c.1-.2-2.8-.2-4.9 1.6ZM191.4 374.3s-.9 1.6-.9 2.2c0 .6.6 1 2.2.6 0 0 2.9-3.6 4.2-4.2 1.3-.6 2.7-1.3 2.7-1.3s-3.3 1.4-4.3 1.6c-.9.2-.9-.5-.8-1 .1-.5.4-1.1 0-1.4-.2-.2-.3-.9-.5-1.6-.2.2-.5.4-.7.6-1 .9-2.5 2.8-3 3.4-.2.7-.3 1.3 1.1 1.1Z",
    fill: "#D9A782"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M210.2 367.8s2.4 4 2.8 6.6c0 0 12.9-3.4 20.4-6.3 7.4-2.9 9.8-4.7 10.9-9.1 1.1-4.4-.5-14-1-17.6-.6-3.5-1.7-6.1-1.7-7.8 0-1.7-1.9-10.5-5.5-12s-12 2.9-11.4 8.5c.6 5.5 4.2 6.1 5.9 11.8 1.6 5.7 3.5 15.2 3.5 15.2s-9.3 4.6-12.7 6c-3.5 1.5-11.2 4.7-11.2 4.7ZM200.8 348.5c.5-4.5 0-11.3 0-11.3s-3-5.4-1.6-14.1c1.1-6.6 3-10.9 3.9-12.7-.9-.1-2.2 0-4.4.6-4.9 1.5-2.5 11.7-2.2 14.1.3 2.3-1.6 11.7-1.6 11.7s-4.2 6.1-7.1 10c-2.9 3.8-6.5 9.8-6.5 9.8 5.6 0 6.7 2.2 6.7 2.2s3-2.5 6.4-5.2c2-1.5 4.5-3.6 6.4-5.1Z",
    fill: "#FE769C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M200.8 348.5c.5-4.5 0-11.3 0-11.3s-3-5.4-1.6-14.1c0-.3.1-.5.1-.7-.6 1.4-1.2 3-1.3 4.9-.2 4.1.1 9.1-1.3 10-1.5.9-1.6 2.3-1.8 2.8-.1.4-5 12.6-8.6 17.6 1.4.6 1.7 1.3 1.7 1.3s3-2.5 6.4-5.2c2-1.7 4.5-3.8 6.4-5.3Z",
    fill: "#FF2363"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M193.6 305.4c-.3 2.6 1.1 5.9 2.5 6.9s3 2.1 3 2.1-.7 5 .6 5.1c1.3 0 2-.4 2-.4s2 .6 2.5 1.2 2.2 1.6 4 .6c1.8-1.1 6.5-4.1 8-8.5s2.2-8.7 1.8-12c-.4-3.4-3.1-9-8.2-10s-10.3-.2-13.7 5.6c-3.3 5.7-2.3 8-2.5 9.4Z",
    fill: "#FFCDA8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5 315.7c1-.9-.5-1.6-2-1.3-1.4.3-6.2 0-7.4 0 0 0-.7 5 .6 5.1 1.3 0 2-.4 2-.4s2 .6 2.5 1.2 2.2 1.6 4 .6c.2-.1.4-.3.7-.4-2.5-1.8-1.3-4-.4-4.8Z",
    fill: "#D9A782"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 310.7c2.5.3 3.8-1.7 7-1.9 3.2-.2 5.6-.1 7 1 1.4 1.1 2.6-.2 2.7-1.3.1-1.1 2.5-2.5 2.5-2.5l1.8.4s2.3-5-1-11.3c-2.5-4.8-6-6.8-12.9-6.2-5.9.5-8.7 4.7-10.9 9.7-2.2 4.9-1.4 11.4 3.8 12.1Z",
    fill: "#303082"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M213.4 308.4c.1-1.1 2.5-2.5 2.5-2.5l1.8.4s1.9-4.1-.2-9.6c-2.6 5.8-8.8 10.4-11.3 12 2 0 3.5.3 4.5 1 1.4 1.1 2.6-.2 2.7-1.3Z",
    fill: "#303082"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 307.8c-.2-.7.7-2.5 1.9-2.6 1.2-.1 1.8.8 1.6 2.1-.2 1.3-1.1 4-2.2 3.7-1-.4-1.1-2.2-1.3-3.2Z",
    fill: "#FFCDA8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m196.3 396.3-6.2-22.1c-.2-.7-.9-1.7-1.6-2.1l-35.9-21.4c-.3-.2-.6-.2-.7-.1l-.6.7c-.1.1-.2.4-.1.7l6.2 22.2c.2.7.9 1.7 1.6 2.1l35.9 21.4c.3.2.5.2.7.1l.6-.7c.1-.1.2-.4.1-.8Z",
    fill: "#005FF1"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M195.7 397c.2.7-.2 1-.8.6L159 376.2c-.7-.4-1.4-1.3-1.6-2.1l-6.2-22.2c-.2-.7.2-1 .8-.6l35.9 21.4c.7.4 1.4 1.3 1.6 2.1l6.2 22.2Z",
    fill: "#003AA5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.5 377c.3 1.8-.8 2.6-2.4 1.7-1.7-.9-3.3-3.1-3.6-4.9-.3-1.8.8-2.6 2.4-1.7 1.7.9 3.3 3.1 3.6 4.9Z",
    fill: "#4CEAF5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.1 376.8c.3 1.6-.7 2.2-2.1 1.4-1.4-.8-2.8-2.6-3.1-4.2-.3-1.6.7-2.2 2.1-1.4 1.5.7 2.8 2.6 3.1 4.2Z",
    fill: "#4CEAF5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M173.8 376.6c.2 1.4-.6 1.9-1.9 1.3-1.3-.7-2.5-2.3-2.7-3.7-.2-1.4.6-1.9 1.9-1.3 1.3.7 2.5 2.3 2.7 3.7Z",
    fill: "#4CEAF5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M173.5 376.4c.2 1.2-.5 1.7-1.6 1.1-1.1-.6-2.2-2-2.4-3.2-.2-1.2.5-1.7 1.6-1.1 1.2.6 2.2 2 2.4 3.2Z",
    fill: "#D4FFFF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M420.2 432.2c.7-.8-.1-1.4-.4-3.1-.3-1.7.9-3.3.9-3.3l16-1.9c-5.1 4-11 14.3-11.3 15.1-.3.8-.7 4.3-1.6 4.7-.8.4-2.5 0-3.1-.8-.6-.8-.4-1.6-.4-1.6s-.7-.3-1.2-1.1 0-2.7 0-2.7-.3-.3-.4-1.3c-.1-1 .8-3.2 1.5-4Z",
    fill: "#BD8668"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M419.8 429.1c-.3-1.7.9-3.3.9-3.3l16-1.9c-5.1 4-11 14.3-11.3 15.1-.1.1-.1.4-.2.6l-.3-.2s.1-1.2-.3-1.2-1.1-.5-1.1-.5l-.7.2-.7-.7c-.5-.5-1.5-.3-3.1.4v-.2s-.3-.3-.4-1.3c-.1-1 .8-3.2 1.6-4 .7-.7-.1-1.3-.4-3Z",
    fill: "#B0795B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M428.6 434.3s-4.4 10.5-5.8 10.5c-1.4 0-4.9-3.8-4.4-8.4.4-4.6 1.8-11.4 1.8-11.4l8-1.7c.1.1-3.1 7.5.4 11Z",
    fill: "#004E4A"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M390.7 395.9s-1.9.4-3.2 1.7c-1.3 1.3-6.7 9.3-4.1 14.8 2.6 5.4 18.1-8.1 18.1-8.1l-10.8-8.4Z",
    fill: "#004F49"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M416.2 389.9s.3 8.6-.3 12c-.6 3.4-2.2 11.3-3.8 11.9-1.6.7-18.9-7-18.9-7l1.9-9.1c.1 0 13.2-1 21.1-7.8Z",
    fill: "#004F49"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M447.3 415.4s8.2-8.8 10-10.8c1.8-2.1 16.2-14.5 13.4-19.7-2.8-5.2-14.3-5.5-17.7-5-3.5.5-24.4 3.6-35.7 10.1 0 0-4 5.2-5 11.6-1 6.4-.4 11.7-.4 11.7l5 .4s4.9-2 8-3.2c3.1-1.3 13.1-4.7 13.1-4.7l-5.8 11.7 15.1-2.1Z",
    fill: "#004F49"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M473.5 411.4s.7-1.4.5-2.1c-.2-.7-2.2-1.5-3.9-1.3-1.7.3-2.9.3-4.1.3-1.2 0-4.4 1-6.5 1.8-2.1.8-6.1 2-7.5 2-1.4 0-3.8 1.2-3.8 1.2s-1.8 0-3.2.7c-1.4.7-4 1.5-5.3 1.5-1.3 0-10-.3-10-.3l-.3 11s13.1-4 14.8-4.4c1.7-.4 7-1.3 8.8-1.4 1.8-.1 5.9-.2 8.1-.7 2.2-.5 3.2-.9 3.2-.9s3.3.2 3.9 0c.6-.2 1.3-1.3 1.3-1.3s1.5-.8 1.3-2c0 0 1.3-.4 1.5-1 .2-.6 0-.9 0-.9s1.8-1 1.2-2.2Z",
    fill: "#BD8668"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M429.6 423.7c2.9-.4 7.9-1.2 12.3-2.7 6.6-2.3 12.2-4 16.9-4.9 4.7-.9 5.8-1.3 6.9-1.1 1.1.2 4 .9 5.4.5.1 1.2-1.3 2-1.3 2s-.6 1.1-1.3 1.3c-.6.2-3.9 0-3.9 0s-1 .4-3.2.9-6.3.6-8.1.7c-1.8.1-7.1.9-8.8 1.4-1.7.4-14.8 4.4-14.8 4.4l-.1-2.5Z",
    fill: "#B0795B"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M441.6 414.1s2.7 2.1 2.7 5.6c0 3.5-1.3 4.7-1.3 4.7s-26.3 4.6-31.8 5.2c-5.5.6-12.8-2.8-15.2-4.2-2.4-1.4-12.7-11-12.6-14 .1-3 5.2-7.6 5.2-7.6s6.1-1.4 11.1-.7 6.1 1 8 3.6c1.9 2.6 3.5 6.5 3.5 6.5s3.5-1.3 9-.8c5.3.5 17.2 2.3 21.4 1.7Z",
    fill: "#018489"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M421.7 362.8s-5.5 15.5-4.4 17.8c1.1 2.3 6 13.7 6 13.7s-4.6 7.5-16.7 8.1c-12.1.6-18.2-4.8-18.2-4.8s5.5-9.4 4.9-16.6c-.6-7.2-5.8-18.2-5.8-18.2l1.2-8.7 33 8.7Z",
    fill: "#F7991D"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M393.4 381c-.6-7.2-5.8-18.2-5.8-18.2l1.2-8.7 32.9 8.7s-1 2.9-2.1 6.4c-2.7 1.3-7.9 3.8-11.9 6.5-5 3.4-11.4 15.5-11.5 25.4-6.4-1.8-7.8-3.5-7.8-3.5s5.5-9.4 5-16.6Z",
    fill: "#F47A21"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m401 400.5 35.1-20.3c.3-.2.8-.2 1.1 0l23 13.3c.2.1.2.2.2.3v.7c0 .1-.1.2-.2.3l-35.1 20.6c-.3.2-.8.2-1.1 0l-23-13.3c-.2-.1-.2-.2-.2-.3v-1.1c-.1 0 0-.1.2-.2Z",
    fill: "#005FF1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M437.2 380.2c-.3-.2-.8-.2-1.1 0L401 400.5c-.3.2-.3.5 0 .7l23 13.3c.3.2.8.2 1.1 0l35.1-20.3c.3-.2.3-.5 0-.7l-23-13.3Z",
    fill: "#279AFF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M444.7 386.4c-.2-.1-.4-.1-.6 0l-32.6 18.8c-.2.1-.2.2 0 .3l9.8 5.6c.2.1.4.1.6 0l32.6-18.8c.2-.1.2-.2 0-.3l-9.8-5.6Z",
    fill: "#000675"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M421.6 390.8c-.3-.2-.8-.2-1.1 0l-7.6 4.4c-.3.2-.3.5 0 .6l5.4 3.1c.3.2.8.2 1.1 0l7.6-4.4c.3-.2.3-.5 0-.7l-5.4-3Z",
    fill: "url(#bb)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m427 394-5.4-3.1c-.3-.2-.8-.2-1.1 0l-7.6 4.4-.2.2c0-.1 0-.3.2-.4l7.6-4.4c.3-.2.8-.2 1.1 0l5.4 3.1c.2.1.3.3.2.4l-.2-.2Z",
    fill: "#000675"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M412.8 395.8c-.1-.1-.1-.3.1-.4l1.3-1 6.2-3.6c.3-.2.8-.2 1.1 0l.6.3.2.2v.1l-4.2 2.4h-.1v.1l-4.3 2.5-.9-.6c.1 0 .1 0 0 0Z",
    fill: "#000675"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m418.2 393.7-1.3-.8 3.8-2.2c.3-.2.7-.2 1 0l.8.5-4.3 2.5Z",
    fill: "url(#bc)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m418.1 393.8-4.3 2.5-.8-.5c-.3-.2-.3-.4 0-.6l3.8-2.2 1.3.8Z",
    fill: "url(#bd)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M421.2 406.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#be)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M423.1 405.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bf)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M424.9 404.2c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bg)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 403.2c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bh)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M428.5 402.1c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bi)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M430.3 401.1c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bj)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M432.1 400.1c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bk)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M433.9 399c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bl)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M435.7 398c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bm)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M437.5 396.9c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bn)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M439.3 395.9c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bo)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M441.1 394.8c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bp)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M443.5 393.4c-.1-.1-.3-.1-.4 0l-1.6.9c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.6-.9c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bq)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M420.5 408.8c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#br)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M422.3 407.7c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bs)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M424 408.9c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bt)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M422.2 410c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bu)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M425.6 408c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bv)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M427.3 407c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bw)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M428.9 406.1c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bx)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M430.6 405.1c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#by)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M432.2 404.1c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bz)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M433.9 403.2c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bA)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M435.6 402.2c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bB)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M437.2 401.3c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bC)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M438.9 400.3c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bD)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 399.4c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bE)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M442.2 398.4c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bF)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M443.9 397.4c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.6.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.6-.3Z",
    fill: "url(#bG)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M445.5 396.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bH)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M447.1 395.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bI)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M448.8 394.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bJ)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M450.4 393.7c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bK)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M452 392.7c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bL)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M453.7 391.8c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l.5.3c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-.5-.3Z",
    fill: "url(#bM)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M424.2 406.7c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bN)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M426 405.7c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bO)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8 404.6c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bP)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M429.6 403.6c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bQ)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M431.4 402.5c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bR)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M433.2 401.5c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bS)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M435 400.4c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bT)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M436.8 399.4c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bU)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M438.6 398.4c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bV)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M440.4 397.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bW)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M442.2 396.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bX)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M446.9 393.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bY)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M448.6 392.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#bZ)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M450.2 391.7c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#ca)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M451.8 390.7c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cb)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M445.1 392.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cc)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M446.8 391.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cd)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M448.4 390.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#ce)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M443.4 391.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cf)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M445 390.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cg)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M446.7 389.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#ch)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M448.3 388.7c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l2.8 1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-2.8-1.6Z",
    fill: "url(#ci)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M441.6 390.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cj)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M440 391.4c-.1-.1-.2-.1-.3 0l-.8.5c-.1.1-.1.1 0 .2l.9.5c.1.1.2.1.3 0l.8-.5c.1-.1.1-.1 0-.2l-.9-.5Z",
    fill: "url(#ck)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M438.3 390.4c-.1-.1-.2-.1-.3 0l-.8.5c-.1.1-.1.1 0 .2l.9.5c.1.1.2.1.3 0l.8-.5c.1-.1.1-.1 0-.2l-.9-.5Z",
    fill: "url(#cl)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M436.7 391.3c-.1-.1-.2-.1-.3 0l-.8.5c-.1.1-.1.1 0 .2l.9.5c.1.1.2.1.3 0l.8-.5c.1-.1.1-.1 0-.2l-.9-.5Z",
    fill: "url(#cm)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M439.8 389.5c-.1-.1-.2-.1-.3 0l-.8.5c-.1.1-.1.1 0 .2l.9.5c.1.1.2.1.3 0l.8-.5c.1-.1.1-.1 0-.2l-.9-.5Z",
    fill: "url(#cn)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M443.2 389.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#co)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M444.9 388.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cp)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M441.5 388.5c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cq)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M443.1 387.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cr)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M444.7 386.6c-.1-.1-.3-.1-.4 0l-.9.5c-.1.1-.1.2 0 .2l2.9 1.7c.1.1.3.1.4 0l.9-.5c.1-.1.1-.2 0-.2l-2.9-1.7Z",
    fill: "url(#cs)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M445.3 394.5c-.1-.1-.3-.1-.4 0l-2.4 1.4c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l2.4-1.4c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#ct)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M419.9 405.1c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cu)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M421.7 404c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cv)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M423.5 403c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cw)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M425.3 402c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cx)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 400.9c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cy)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M428.9 399.9c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cz)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M430.7 398.8c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cA)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M432.6 397.8c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cB)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M434.4 396.7c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cC)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M436.2 395.7c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cD)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M438 394.7c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cE)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M441.8 392.5c-.1-.1-.3-.1-.4 0l-3.1 1.8c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l3.1-1.8c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cF)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M419 403.5c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cG)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M419.4 407.4c-.1-.1-.3-.1-.4 0l-1.8 1c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.8-1c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cH)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M418.1 406.1c-.1-.1-.3-.1-.4 0l-2.2 1.3c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l2.2-1.3c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cI)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M417.2 404.6c-.1-.1-.3-.1-.4 0l-3.1 1.8c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l3.1-1.8c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cJ)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M420.8 402.5c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cK)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M422.6 401.4c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cL)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M415.4 403.5c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cM)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M413.6 404.6c-.1-.1-.3-.1-.4 0l-1.3.7c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.3-.7c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cN)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M417.2 402.5c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cO)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M419.3 401.3c-.1-.1-.3-.1-.4 0l-1.4.8c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.4-.8c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cP)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8 396.4c-.1-.1-.3-.1-.4 0l-7.8 4.5c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l7.8-4.5c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cQ)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M424.4 400.4c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cR)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M426.2 399.4c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cS)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M428 398.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cT)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M429.9 397.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cU)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M431.7 396.2c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cV)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M433.5 395.2c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cW)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M435.3 394.1c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cX)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M429.6 395.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cY)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M431.4 394.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#cZ)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M433.2 393.3c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#da)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M435 392.2c-.1-.1-.3-.1-.4 0l-1.1.6c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l1.1-.6c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#db)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M438.4 392.3c-.1-.1-.3-.1-.4 0l-2.5 1.4c-.1.1-.1.2 0 .2l1.1.6c.1.1.3.1.4 0l2.5-1.4c.1-.1.1-.2 0-.2l-1.1-.6Z",
    fill: "url(#dc)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 331.9s3.8 1.7 4.6 4.6c.8 2.9 1.3 9.1 2.3 11.1 1 2.1 8.2 9 6.1 14-2.1 5-6.2 4.2-11.1 7.5-4.9 3.3-15.3 7.1-18.6.1-3.3-6.9-3.5-10.9-6.3-12.2-2.9-1.2-4.8-14.5-4.8-14.5l9.8-10.3 18-.3Z",
    fill: "#F7991D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M412.6 393.9c.9 0 4.8-.5 6.8-1s8.1-.4 9.7.4c1.6.7 4 3.7 3.9 4.1-.1.4-.4.4-.4.4s1.4 2.2.7 2.4c-.7.2-1.9-.9-2.9-1.7-1-.7-2.3-1.6-3.4-1.6h-2.4s2.1 1.1 3.2 1.5c1.1.4 4.7 3.3 3.8 4-.9.6-1.5-.2-2.4-.8-.9-.6-4.5-2.6-5-2.7-.5-.1-1.2.6-1.2.6s4.4 3.7 4.8 4.1c.4.4.2 1.1-.3 1.1s-4.1-2.7-4.9-3.2c-.8-.5-2.9-1-3.7-1-.8 0-4 .2-5.3 0-1.3-.2-3.4-1.3-3.4-1.3s-8.5-1.1-13.2-2c-4.7-.9-17.1-6.3-17.8-8.6-.7-2.3-.6-15.9-.6-20.4.1-4.5.6-12.8.6-12.8l10.9 1.3s-.3 8.1-.9 13.3c-.6 5.2-1.6 12.8-1.6 12.8s8.2 4.7 12.9 6.9c4.6 1.9 11.3 4.2 12.1 4.2Z",
    fill: "#FFCDA8"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M380.2 389.5c1.9 1 5.7 2.8 11.8 4.3 9 2.3 17.7 2.4 19.1 3.5 1.4 1.1 1.6 1.3 2.1 1.8.3.3 2.6.6 4.6 1.1-1.3 0-3.4.1-4.4-.1-1.3-.2-3.4-1.3-3.4-1.3s-8.5-1.1-13.2-2c-3.9-.7-13.4-4.7-16.6-7.3Z",
    fill: "#D9A782"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M424.4 361.6c2.1-5-5.1-11.9-6.1-14-.3-.7-.6-1.8-.8-3l3.6-1.8c.7 2.1 4 9.1 5.5 11.7 1.5 2.6 4.8 8.3 5.1 8.9.3.6 4.3 5.6 5.8 8.4 1.4 2.8 4.7 11 4.7 11s3.3 1.1 4.3 2.3c1 1.2 2.3 5.2 2.3 6.8 0 1.5.1 2.3-.4 1.9-.5-.4-1-1-1.2-1.1-.2-.1-2-4.5-2-4.5s.2 5.9-.7 5.7c-.8-.2-1.1-2.4-1.1-2.6 0-.2-.7-4.4-1.2-4.6-.6-.2-1.2.4-1.3.5-.1.1.4 5.6-.1 5.7-.5.1-1.7-1.5-1.7-2.4-.1-.9-.3-3.4-.3-3.4s-2.4.7-2.5 1.1c-.1.4-.8 3.7-.8 3.7s-.9.5-1.3-2 0-3.6.2-4c.2-.4 1.4-2.4 1.4-2.4s-1.4-3.7-2.7-4.5c-1.3-.8-6.2-6.2-8.2-9.8-.7-1.2-1.6-2.9-2.5-4.5.7-.7 1.5-1.7 2-3.1Z",
    fill: "#FFCDA8"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M424.4 361.6c2.1-5-5.1-11.9-6.1-14-.3-.7-.6-1.8-.8-3l1.8-.9s2.2 5.4 4.4 9c2.2 3.7 6.4 9.2 7 10.1.6.9-.9 1.8-2.1 2.6-1.2.8-.7 3.8 1 6.8 1.5 2.8 7.6 8.7 6 11.2-.1-.2-1.5-3.7-2.7-4.5-1.3-.8-6.2-6.2-8.2-9.8-.7-1.2-1.6-2.9-2.5-4.5.9-.6 1.7-1.6 2.2-3Z",
    fill: "#D9A782"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M416.1 336.5c-.4-1.5-1.6-2.7-2.7-3.4v-.3c7.2 1.7 8.8 11.1 8.8 11.1l-4.1 3c-.9-2.5-1.3-7.8-2-10.4Z",
    fill: "#F47A21"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M391 360.3s-8.3-.1-12.5-3.6c0 0-1.3-6.8 5.4-14.4.1-.1 11.5.2 7.1 18Z",
    fill: "#F7991D"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M410.2 333.2s5.1 13-.4 14.8c-5.5 1.8-15.7-7.9-16.9-13.9-1.1-6 14.7-5 17.3-.9Z",
    fill: "#D9A782"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M395.8 333c-.8-.6-1-1.4-.8-2.3 4.2-1.9 13.3-.6 15.2 2.5 0 0 5.1 13-.4 14.8-1.5.5-3.3.1-5.2-.8-1.8-4.4-5-11.3-8.8-14.2Z",
    fill: "#C08E69"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m416.7 325.5-.9 2s0 2.3-.3 3c-.3.7-1.3 2.5-1.3 2.5s.3 2.2 0 2.3c-.3.1-.8.1-.8.1s-1.9 4.2-3.4 4.6c-1.5.4-5.3-.3-8.4-3.1-3.1-2.8-6.2-7-7.7-12.2-1.5-5.2-.9-10.3 1.1-13.3 2.1-3 8.6-5.8 13.7-3.4 5.2 2.5 7.6 8.6 8.1 11.8.4 3.2-.1 5.7-.1 5.7Z",
    fill: "#FFCDA8"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "m416.3 326.3-.5 1.2s0 2.3-.3 3c-.3.7-1.3 2.5-1.3 2.5s-.6-2.8-.6-4c-.1-.6 1.4-1.8 2.7-2.7ZM410.6 335.6c.4-.2 2.7-.1 2.7-.1-.2.5-2 4.1-3.4 4.5-.5.1-1.3.1-2.2 0 .9-1 2.5-4.3 2.9-4.4Z",
    fill: "#D9A782"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M418.4 321.6c0 .4-.3 4.7-8.3 6.2-9.8 1.8-11.9 3.1-14 7.6-2.1 4.5-13.1 7.4-13.1 7.4s4.8-3.9 7-9.5c2.3-5.6 1.8-12.3 2.1-16.3.3-4 3-9.6 9.8-10.9 6.9-1.3 15.1 2.5 16.5 15.5Z",
    fill: "#008289"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "m425.2 413.7 5.7-20.6c.2-.7.8-1.6 1.5-1.9l33.5-20c.3-.2.6-.2.7-.1l.6.6c.1.1.2.3.1.7l-5.7 20.6c-.2.7-.9 1.6-1.5 1.9l-33.5 19.9c-.3.2-.5.2-.7.1l-.6-.6c-.1 0-.2-.2-.1-.6Z",
    fill: "#005FF1"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M425.8 414.3c-.2.7.2 1 .8.6L460 395c.6-.4 1.3-1.2 1.5-1.9l5.7-20.6c.2-.7-.2-1-.8-.6l-33.5 20c-.6.4-1.3 1.2-1.5 1.9l-5.6 20.5Z",
    fill: "#003AA5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M445.5 395.7c-.3 1.7.7 2.4 2.3 1.5 1.6-.8 3-2.9 3.3-4.6.3-1.7-.7-2.4-2.3-1.5-1.6.9-3.1 2.9-3.3 4.6Z",
    fill: "#4CEAF5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M445.8 395.5c-.3 1.4.6 2 2 1.3 1.3-.7 2.6-2.5 2.9-3.9.3-1.4-.6-2-2-1.3-1.3.7-2.6 2.4-2.9 3.9Z",
    fill: "#4CEAF5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M446.1 395.3c-.2 1.3.5 1.8 1.7 1.2 1.2-.6 2.3-2.2 2.5-3.5.2-1.3-.5-1.8-1.7-1.2-1.1.7-2.3 2.3-2.5 3.5Z",
    fill: "#4CEAF5"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M446.4 395.2c-.2 1.1.5 1.6 1.5 1 1-.6 2-1.9 2.2-3 .2-1.1-.5-1.6-1.5-1-1 .5-2 1.9-2.2 3Z",
    fill: "#D4FFFF"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M461.7 409.1s8.3-2.8 12.7 0c4.4 2.8-.6 8.4-5 10.2-4.3 1.8-14.6 1-14.6 1s9.4-2.8 9-5.9c-.6-4.8-8.7-3.1-8.7-3.1l6.6-2.2Z",
    fill: "#004E4A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 423.888,
    y1: 388.374,
    x2: 413.063,
    y2: 406.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 255.689,
    y1: 315.03,
    x2: 470.016,
    y2: 315.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0045D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 178.515,
    y1: 364.918,
    x2: 223.351,
    y2: 413.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 178.01,
    y1: 365.363,
    x2: 222.865,
    y2: 414.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 177.525,
    y1: 365.83,
    x2: 222.354,
    y2: 414.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 177.023,
    y1: 366.28,
    x2: 221.865,
    y2: 415.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 176.544,
    y1: 366.754,
    x2: 221.34,
    y2: 415.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 176.046,
    y1: 367.207,
    x2: 220.843,
    y2: 416.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 175.542,
    y1: 367.656,
    x2: 220.357,
    y2: 416.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 175.048,
    y1: 368.114,
    x2: 219.851,
    y2: 417.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 174.549,
    y1: 368.565,
    x2: 219.358,
    y2: 417.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 174.047,
    y1: 369.015,
    x2: 218.877,
    y2: 417.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 173.55,
    y1: 369.469,
    x2: 218.387,
    y2: 418.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 173.054,
    y1: 369.925,
    x2: 217.882,
    y2: 418.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 172.465,
    y1: 370.47,
    x2: 217.273,
    y2: 419.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 177.597,
    y1: 365.744,
    x2: 222.445,
    y2: 414.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 177.11,
    y1: 366.21,
    x2: 221.941,
    y2: 415.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 175.764,
    y1: 367.481,
    x2: 220.555,
    y2: 416.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 176.23,
    y1: 366.993,
    x2: 221.081,
    y2: 415.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 175.31,
    y1: 367.898,
    x2: 220.098,
    y2: 416.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 174.834,
    y1: 368.293,
    x2: 219.665,
    y2: 417.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 174.399,
    y1: 368.729,
    x2: 219.185,
    y2: 417.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 173.929,
    y1: 369.131,
    x2: 218.749,
    y2: 418.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 173.484,
    y1: 369.557,
    x2: 218.274,
    y2: 418.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 173.024,
    y1: 369.969,
    x2: 217.824,
    y2: 418.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 172.561,
    y1: 370.376,
    x2: 217.389,
    y2: 419.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 172.111,
    y1: 370.797,
    x2: 216.925,
    y2: 419.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 171.64,
    y1: 371.196,
    x2: 216.519,
    y2: 420.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 171.2,
    y1: 371.629,
    x2: 216.016,
    y2: 420.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 170.741,
    y1: 372.042,
    x2: 215.572,
    y2: 421.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 170.273,
    y1: 372.48,
    x2: 215.073,
    y2: 421.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 169.817,
    y1: 372.888,
    x2: 214.656,
    y2: 421.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 169.37,
    y1: 373.297,
    x2: 214.207,
    y2: 422.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 168.926,
    y1: 373.707,
    x2: 213.737,
    y2: 422.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 168.476,
    y1: 374.121,
    x2: 213.242,
    y2: 423.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 168.029,
    y1: 374.527,
    x2: 212.885,
    y2: 423.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 167.576,
    y1: 374.938,
    x2: 212.358,
    y2: 423.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 176.618,
    y1: 366.67,
    x2: 221.438,
    y2: 415.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 176.114,
    y1: 367.116,
    x2: 220.95,
    y2: 416.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 175.622,
    y1: 367.576,
    x2: 220.447,
    y2: 416.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 175.122,
    y1: 368.026,
    x2: 219.958,
    y2: 417.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 174.634,
    y1: 368.492,
    x2: 219.443,
    y2: 417.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 174.127,
    y1: 368.937,
    x2: 218.965,
    y2: 417.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 173.638,
    y1: 369.399,
    x2: 218.452,
    y2: 418.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 173.143,
    y1: 369.856,
    x2: 217.948,
    y2: 418.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 172.64,
    y1: 370.303,
    x2: 217.471,
    y2: 419.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 172.144,
    y1: 370.759,
    x2: 216.969,
    y2: 419.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 171.639,
    y1: 371.225,
    x2: 216.456,
    y2: 420.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 170.319,
    y1: 372.433,
    x2: 215.128,
    y2: 421.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 169.867,
    y1: 372.844,
    x2: 214.678,
    y2: 421.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 169.421,
    y1: 373.253,
    x2: 214.26,
    y2: 422.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 168.97,
    y1: 373.665,
    x2: 213.804,
    y2: 422.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 171.916,
    y1: 370.969,
    x2: 216.733,
    y2: 419.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 171.466,
    y1: 371.381,
    x2: 216.273,
    y2: 420.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 171.019,
    y1: 371.79,
    x2: 215.818,
    y2: 420.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 173.462,
    y1: 369.553,
    x2: 218.28,
    y2: 418.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 173.014,
    y1: 369.966,
    x2: 217.807,
    y2: 418.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 172.565,
    y1: 370.373,
    x2: 217.398,
    y2: 419.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 171.341,
    y1: 371.493,
    x2: 216.167,
    y2: 420.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 175.069,
    y1: 368.083,
    x2: 219.885,
    y2: 417.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 175.507,
    y1: 367.679,
    x2: 220.347,
    y2: 416.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 177.097,
    y1: 366.23,
    x2: 221.901,
    y2: 415.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 177.534,
    y1: 365.822,
    x2: 222.366,
    y2: 414.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 176.671,
    y1: 366.624,
    x2: 221.454,
    y2: 415.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 174.622,
    y1: 368.497,
    x2: 219.398,
    y2: 417.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 174.172,
    y1: 368.902,
    x2: 219.026,
    y2: 417.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 176.216,
    y1: 367.031,
    x2: 221.049,
    y2: 416.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 175.77,
    y1: 367.44,
    x2: 220.572,
    y2: 416.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 174.521,
    y1: 368.583,
    x2: 219.356,
    y2: 417.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 170.967,
    y1: 371.84,
    x2: 215.777,
    y2: 420.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 179.963,
    y1: 363.616,
    x2: 224.775,
    y2: 412.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 179.455,
    y1: 364.059,
    x2: 224.289,
    y2: 413.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 178.961,
    y1: 364.517,
    x2: 223.79,
    y2: 413.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 178.463,
    y1: 364.971,
    x2: 223.295,
    y2: 413.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 177.966,
    y1: 365.424,
    x2: 222.8,
    y2: 414.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 177.466,
    y1: 365.875,
    x2: 222.312,
    y2: 414.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 176.977,
    y1: 366.34,
    x2: 221.798,
    y2: 415.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 176.48,
    y1: 366.795,
    x2: 221.297,
    y2: 415.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 175.977,
    y1: 367.242,
    x2: 220.823,
    y2: 416.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 175.487,
    y1: 367.705,
    x2: 220.303,
    y2: 416.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 174.987,
    y1: 368.156,
    x2: 219.817,
    y2: 417.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 174.214,
    y1: 368.866,
    x2: 219.034,
    y2: 417.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 181.323,
    y1: 362.375,
    x2: 226.131,
    y2: 411.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 179.115,
    y1: 364.38,
    x2: 223.939,
    y2: 413.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 180.594,
    y1: 363,
    x2: 225.442,
    y2: 411.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 182.083,
    y1: 361.651,
    x2: 226.919,
    y2: 410.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 180.813,
    y1: 362.814,
    x2: 225.649,
    y2: 411.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 180.326,
    y1: 363.281,
    x2: 225.139,
    y2: 412.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 183.404,
    y1: 360.443,
    x2: 228.238,
    y2: 409.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 183.931,
    y1: 359.963,
    x2: 228.763,
    y2: 408.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 182.914,
    y1: 360.903,
    x2: 227.738,
    y2: 409.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 182.393,
    y1: 361.404,
    x2: 227.191,
    y2: 410.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 180.935,
    y1: 362.715,
    x2: 225.757,
    y2: 411.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 179.83,
    y1: 363.735,
    x2: 224.643,
    y2: 412.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 179.332,
    y1: 364.189,
    x2: 224.144,
    y2: 413.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 178.824,
    y1: 364.632,
    x2: 223.669,
    y2: 413.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 178.331,
    y1: 365.091,
    x2: 223.165,
    y2: 414.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 177.842,
    y1: 365.553,
    x2: 222.65,
    y2: 414.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 177.343,
    y1: 366.006,
    x2: 222.155,
    y2: 414.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 176.843,
    y1: 366.457,
    x2: 221.673,
    y2: 415.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 179.494,
    y1: 363.998,
    x2: 224.379,
    y2: 413.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 179.017,
    y1: 364.473,
    x2: 223.835,
    y2: 413.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 178.52,
    y1: 364.93,
    x2: 223.33,
    y2: 413.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 178.019,
    y1: 365.379,
    x2: 222.853,
    y2: 414.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 176.162,
    y1: 367.087,
    x2: 220.971,
    y2: 416.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 199.229,
    y1: 368.183,
    x2: 210.852,
    y2: 387.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 422.442,
    y1: 387.496,
    x2: 411.616,
    y2: 405.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 420.475,
    y1: 386.298,
    x2: 409.644,
    y2: 404.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 441.744,
    y1: 384.454,
    x2: 399.967,
    y2: 430.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 442.22,
    y1: 384.863,
    x2: 400.416,
    y2: 430.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 442.673,
    y1: 385.299,
    x2: 400.891,
    y2: 430.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 443.117,
    y1: 385.742,
    x2: 401.379,
    y2: 431.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 443.585,
    y1: 386.16,
    x2: 401.835,
    y2: 431.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 444.056,
    y1: 386.576,
    x2: 402.286,
    y2: 432.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 444.526,
    y1: 386.993,
    x2: 402.737,
    y2: 432.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 444.976,
    y1: 387.431,
    x2: 403.228,
    y2: 433.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 445.44,
    y1: 387.851,
    x2: 403.691,
    y2: 433.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 445.912,
    y1: 388.267,
    x2: 404.131,
    y2: 433.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 446.371,
    y1: 388.695,
    x2: 404.607,
    y2: 434.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 446.833,
    y1: 389.12,
    x2: 405.073,
    y2: 434.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 447.389,
    y1: 389.621,
    x2: 405.599,
    y2: 435.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 442.608,
    y1: 385.215,
    x2: 400.803,
    y2: 430.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 443.081,
    y1: 385.626,
    x2: 401.254,
    y2: 431.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 444.36,
    y1: 386.786,
    x2: 402.522,
    y2: 432.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 443.861,
    y1: 386.401,
    x2: 402.093,
    y2: 432.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 444.762,
    y1: 387.199,
    x2: 402.966,
    y2: 432.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 445.148,
    y1: 387.628,
    x2: 403.437,
    y2: 433.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 445.575,
    y1: 388.009,
    x2: 403.855,
    y2: 433.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 446.042,
    y1: 388.353,
    x2: 404.218,
    y2: 434.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 446.446,
    y1: 388.764,
    x2: 404.681,
    y2: 434.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 446.854,
    y1: 389.168,
    x2: 405.132,
    y2: 434.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 447.29,
    y1: 389.544,
    x2: 405.536,
    y2: 435.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 447.731,
    y1: 389.913,
    x2: 405.91,
    y2: 435.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 448.144,
    y1: 390.313,
    x2: 406.367,
    y2: 435.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 448.579,
    y1: 390.69,
    x2: 406.747,
    y2: 436.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 448.994,
    y1: 391.087,
    x2: 407.198,
    y2: 436.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 449.429,
    y1: 391.496,
    x2: 407.667,
    y2: 437.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 449.86,
    y1: 391.872,
    x2: 408.031,
    y2: 437.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 450.268,
    y1: 392.259,
    x2: 408.491,
    y2: 437.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 450.687,
    y1: 392.64,
    x2: 408.89,
    y2: 438.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 451.103,
    y1: 393.025,
    x2: 409.367,
    y2: 438.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 451.52,
    y1: 393.406,
    x2: 409.767,
    y2: 439.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 451.941,
    y1: 393.788,
    x2: 410.228,
    y2: 439.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 443.521,
    y1: 386.075,
    x2: 401.738,
    y2: 431.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 443.974,
    y1: 386.511,
    x2: 402.214,
    y2: 432.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 444.468,
    y1: 386.9,
    x2: 402.632,
    y2: 432.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 444.898,
    y1: 387.362,
    x2: 403.149,
    y2: 432.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 445.378,
    y1: 387.765,
    x2: 403.578,
    y2: 433.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 445.819,
    y1: 388.215,
    x2: 404.091,
    y2: 433.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 446.299,
    y1: 388.62,
    x2: 404.511,
    y2: 434.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 446.768,
    y1: 389.035,
    x2: 404.954,
    y2: 434.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 447.22,
    y1: 389.471,
    x2: 405.449,
    y2: 435.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 447.68,
    y1: 389.901,
    x2: 405.936,
    y2: 435.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 448.153,
    y1: 390.331,
    x2: 406.404,
    y2: 435.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 449.389,
    y1: 391.45,
    x2: 407.581,
    y2: 437.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 449.805,
    y1: 391.837,
    x2: 408.069,
    y2: 437.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 450.223,
    y1: 392.216,
    x2: 408.418,
    y2: 437.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 450.644,
    y1: 392.6,
    x2: 408.942,
    y2: 438.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 447.899,
    y1: 390.087,
    x2: 406.1,
    y2: 435.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 448.317,
    y1: 390.472,
    x2: 406.526,
    y2: 436.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 448.733,
    y1: 390.853,
    x2: 406.924,
    y2: 436.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 446.459,
    y1: 388.767,
    x2: 404.653,
    y2: 434.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 446.877,
    y1: 389.153,
    x2: 405.067,
    y2: 434.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 447.293,
    y1: 389.534,
    x2: 405.47,
    y2: 435.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 448.432,
    y1: 390.578,
    x2: 406.667,
    y2: 436.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 444.962,
    y1: 387.396,
    x2: 403.16,
    y2: 433.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 444.547,
    y1: 387.026,
    x2: 402.797,
    y2: 432.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 443.07,
    y1: 385.671,
    x2: 401.307,
    y2: 431.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 442.663,
    y1: 385.29,
    x2: 400.867,
    y2: 430.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 443.468,
    y1: 386.039,
    x2: 401.722,
    y2: 431.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 445.379,
    y1: 387.781,
    x2: 403.588,
    y2: 433.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 445.794,
    y1: 388.163,
    x2: 404.03,
    y2: 433.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 443.888,
    y1: 386.421,
    x2: 402.122,
    y2: 432.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 444.304,
    y1: 386.802,
    x2: 402.558,
    y2: 432.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 445.468,
    y1: 387.867,
    x2: 403.675,
    y2: 433.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 448.779,
    y1: 390.902,
    x2: 407.034,
    y2: 436.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 440.397,
    y1: 383.239,
    x2: 398.639,
    y2: 428.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 440.883,
    y1: 383.637,
    x2: 399.078,
    y2: 429.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 441.321,
    y1: 384.089,
    x2: 399.57,
    y2: 429.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 441.795,
    y1: 384.501,
    x2: 400.018,
    y2: 430.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 442.253,
    y1: 384.929,
    x2: 400.49,
    y2: 430.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 442.703,
    y1: 385.368,
    x2: 400.978,
    y2: 430.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 443.178,
    y1: 385.777,
    x2: 401.416,
    y2: 431.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 443.647,
    y1: 386.194,
    x2: 401.866,
    y2: 431.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 444.117,
    y1: 386.611,
    x2: 402.304,
    y2: 432.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 444.578,
    y1: 387.038,
    x2: 402.775,
    y2: 432.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 445.034,
    y1: 387.468,
    x2: 403.262,
    y2: 433.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 445.755,
    y1: 388.129,
    x2: 403.988,
    y2: 433.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 439.148,
    y1: 382.06,
    x2: 397.354,
    y2: 427.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 441.179,
    y1: 383.958,
    x2: 399.422,
    y2: 429.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 439.804,
    y1: 382.67,
    x2: 398.02,
    y2: 428.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 438.412,
    y1: 381.418,
    x2: 396.65,
    y2: 427.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 439.618,
    y1: 382.479,
    x2: 397.81,
    y2: 428.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 440.055,
    y1: 382.928,
    x2: 398.302,
    y2: 428.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 437.18,
    y1: 380.291,
    x2: 395.42,
    y2: 425.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 436.687,
    y1: 379.847,
    x2: 394.93,
    y2: 425.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 437.662,
    y1: 380.696,
    x2: 395.863,
    y2: 426.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 438.148,
    y1: 381.16,
    x2: 396.371,
    y2: 426.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 439.496,
    y1: 382.394,
    x2: 397.717,
    y2: 428.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 440.529,
    y1: 383.339,
    x2: 398.748,
    y2: 428.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 440.992,
    y1: 383.764,
    x2: 399.216,
    y2: 429.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 441.467,
    y1: 384.175,
    x2: 399.649,
    y2: 429.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 441.926,
    y1: 384.603,
    x2: 400.12,
    y2: 430.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 442.376,
    y1: 385.04,
    x2: 400.614,
    y2: 430.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 442.847,
    y1: 385.458,
    x2: 401.054,
    y2: 431.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 443.303,
    y1: 385.887,
    x2: 401.539,
    y2: 431.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 440.826,
    y1: 383.602,
    x2: 399.024,
    y2: 429.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 441.29,
    y1: 384.025,
    x2: 399.483,
    y2: 429.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 441.743,
    y1: 384.459,
    x2: 399.98,
    y2: 430.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 442.209,
    y1: 384.882,
    x2: 400.435,
    y2: 430.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 443.947,
    y1: 386.465,
    x2: 402.145,
    y2: 432.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2580D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A208F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLaptopManWoman);
export default __webpack_public_path__ + "static/media/hero_laptop_man_woman.0ac0b347039a587d3b2d7649b18852eb.svg";
export { ForwardRef as ReactComponent };